module.exports = __webpack_public_path__ + "img/symbol_2.d85af194.png";